// generated from 10_234 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const sessionCountFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("session_count_filter"),
  comparison_key: z.enum([
    "3", // 7_691 (75.15%)
    "1", // 1_326 (12.96%)
    "5", // 1_217 (11.89%)
  ]),
  display_name: z.string(),
  // undefined: 7_010 (68.50%), defined 3_224 (31.50%)
  // avg: 4807.78, min: -1, max: 5465132
  raw_value: z.int().optional(),
  // avg: 3924802.37, min: -1, max: 100000000
  value: z.int(),
  varies_by_app_group: z.literal(false),
});
